import React from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const DealersCircleForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent; // UMS red accent

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        Dealer’s Circle Configuration
      </Typography>

      <Grid container spacing={2}>
        {/* Environment */}
        <Grid item xs={6}>
          <TextField
            label="Environment"
            fullWidth
            value={config.dealersCircleEnvironment || ""}
            onChange={(e) => onChange("dealersCircleEnvironment", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Dealer ID */}
        <Grid item xs={6}>
          <TextField
            label="Dealer Circle ID"
            fullWidth
            value={config.dealersCircleId || ""}
            onChange={(e) => onChange("dealersCircleId", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Syndication Image Groups */}
        <Grid item xs={12}>
          <TextField
            label="Syndication Image Groups"
            fullWidth
            value={config.syndicationImageGroups || ""}
            onChange={(e) => onChange("syndicationImageGroups", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DealersCircleForm;
